import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	EditEmployeeTransactionsContainer,
	EditItemsContainer,
} from "./style";
import { MobileAppVersionItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useMobileAppVersionContext } from "../../context/MobileAppVersionContext/MobileAppVersionContext";

const AddMobileAppVersion = () => {
	const { addMobileAppVersion, loadingAddMobileAppVersionData } = useMobileAppVersionContext();
	return (
		<EditEmployeeTransactionsContainer>
			<EditItemsContainer>
				<h3>Yeni Mobil Uygulama Sürümü Ekleme</h3>
				<Divider />
				<Collapse
					items={MobileAppVersionItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addMobileAppVersion} loading={loadingAddMobileAppVersionData}>
						Sürümü Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</EditItemsContainer>
		</EditEmployeeTransactionsContainer>
	);
};

export default AddMobileAppVersion;
